import React from 'react';
import { Button, Modal } from 'react-bootstrap';
export default class EndModal extends React.Component{
  static displayName = 'EndModal';
  constructor(props) {
    super(props);
    this.state = {
      content: '',
      showModal: true,
      accepted: false,
      callbackFunc: this.props.termsCallback
     };
     this.modalRef = React.createRef();
  }
  backdrop() {
    return <div className='modal-backdrop in' />;
  }

  modal() {
    var style = {display: 'block'};
    return (
      <div
        className='modal in'
        tabIndex='-1'
        role='dialog'
        aria-hidden='false'
        ref='modal'
        style={style}
      >
        <div className='modal-dialog modal-sm'>
          <div className='modal-content'>
            {"Hey Yall"}
            hello
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
  componentDidMount() {
    this.loadAutomatedNegotiationActions();
  }
  loadAutomatedNegotiationActions() {
    var scope = this;
    $.ajax({
      url: "/api/v1/negotiations/" + this.props.negotiation_id + "/get_end_agreement",
      dataType: 'json',
      success: function(data) {
        //console.log("this");
        //console.log(this);
        //this.setState({automated_negotiation_actions: data[0].automated_negotiation_actions.sort(function (a, b) { return a.session - b.session; }) });
        console.log(data);
        this.setState({content: data.end_framework});
        this.setState({accepted: data.accepted});
      }.bind(this),
     error: function(xhr, status, err) {
       console.error("/api/v1/negotiations/" + this.props.negotiation_id + "/get_end_agreement", status, err.toString());
      }.bind(this)
   });
  }
  handleEndYes() {
    $.ajax({
      url: "/api/v1/negotiations/" + this.props.negotiation_id + "/sign_end",
      dataType: 'json',
      success: function(data) {
        //console.log("this");
        //console.log(this);
        this.setState({accepted: true});
        this.props.termsCallback(true);
      }.bind(this),
     error: function(xhr, status, err) {
       console.error("/api/v1/negotiations/" + this.props.negotiation_id + "/sign_end", status, err.toString());
      }.bind(this)
    });
    this.props.handleClose();
    window.jQuery(this.modalRef).modal('hide');
  }
  handleEndNo() {
    $.ajax({
      url: "/api/v1/negotiations/" + this.props.negotiation_id + "/unsign_end",
      dataType: 'json',
      success: function(data) {
        //console.log("this");
        //console.log(this);
        this.setState({accepted: false});
        this.props.termsCallback(false);
      }.bind(this),
     error: function(xhr, status, err) {
       console.error("/api/v1/negotiations/" + this.props.negotiation_id + "/unsign_end", status, err.toString());
      }.bind(this)
    });
    this.props.handleNoClose();
    window.jQuery(this.modalRef).modal('hide');
  }
  hideModal() {
    window.jQuery(this.modalRef).modal('hide');
    this.setState({showModal: false});
  }
  showModalClick() {
    window.jQuery(this.modalRef).modal('show');
    this.setState({showModal: true});
  }
  render() {
    return (
      <div style={{display: "inline-block"}}>
        <span
          style={{cursor: "pointer"}}
          onClick={this.showModalClick}
        > 
          <input className="no-margin-top" type="checkbox" checked={this.props.expert_neutral_terms}/>&nbsp;{this.props.text} <u>{I18n.components.expert_neutral_toggle.use_edc_mandat}</u>
        </span>

        <div className="modal fade" tabIndex="-1" role="dialog" ref={this.modalRef}>
          <div className="modal-dialog" style={{"overflowY": "initial"}}>
            <div className="modal-content">
              <div className="modal-body" style={{"overflowY": "auto"}, {height: "500px"}}>
                <div style={{color: "black"}} dangerouslySetInnerHTML={{ __html: this.state.content }} />
              </div>
              <div className="modal-footer">
                <Button className="btn-nomargin" onClick={this.handleEndYes} variant="success" bsSize="small" style={{marginRight: "5px"}}>{I18n.components.end_modal.accept}</Button>
                <Button className="btn-nomargin" onClick={this.handleEndNo} variant="success" bsSize="small" style={{marginRight: "5px"}}>{I18n.components.end_modal.decline}</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
